import React, { Fragment } from 'react';
import { CardBody, Card } from 'reactstrap';
import {
    Separator, Colxx
} from '../../../../../components/common/CustomBootstrap';

export default function Example({ url, height }) {
    return (
        <Card className="mt-4">
            <CardBody className="p-0 m-0">
                <Card className="m-4 p-4">
                    <Colxx xxs="12 " className="p-0">
                        <div className="text-center">
                            <h6> Example </h6>
                            <Separator className="mb-3" />
                            <img
                                src={url}
                                alt="example"
                                width="auto"
                                style={{ height: height === undefined ? "" : height }}
                                className="img-thumbnail"
                            />
                        </div>
                    </Colxx>
                </Card>
            </CardBody>
        </Card>
    );
}
